import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PostConsultationBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Creates a new consultation. When no clinicId or staffId is provided, it is created as a pending remote consultation. */
export function useCreateConsultation() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: PostConsultationBody) => {
      const response = await api.post('/consultations', { body })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['consultations'] })
      queryClient.invalidateQueries({ queryKey: ['patient-timeline', variables.patientId] })
    },
  })
}
